import pieChartsTag from "@client/content/hocs/piecharts";
import { type PieChartsOptions } from "@client/lib/jquery/piecharts";
import classnames from "classnames";
import * as React from "react";

export interface PieChartsProps {
  iconClassName?: string;
  showPercent: boolean;
  percent: number;
  pieRadius: number;
  options: PieChartsOptions;
}

{
  /* notice key! We force react to change underlying HTML DOM, cause easyPieCharts lib does support dynamic updates */
}
const PieChartsDiv = pieChartsTag<HTMLDivElement>("div");

const PieCharts = React.memo((props: PieChartsProps) => (
  <PieChartsDiv key={Date.now()} className="pie-chart" data-percent={props.percent} pieChartsOptions={props.options}>
    {props.showPercent /* props.pieRadius === 80 should be removed when obsolete PieCharts (not PieChart) is removed */ ? (
      <span className={classnames("percent", { "text-small": props.pieRadius === 80 })} />
    ) : (
      <i className={classnames("empt-sep", props.iconClassName, { "text-small": props.pieRadius === 80 })} />
    )}
  </PieChartsDiv>
));
export default PieCharts;
